<template>
	<div class="flex justify-start w-full mt-3">
		<div class="w-full">
			<div v-if="nextImage" class="flex flex-grow justify-center">
				<RepairProofCamera
					:is-optional-damage-image="isOptionalNextImage"
					get-authenticated-user-group-level="5"
					:repair-proof="getNextImage()"
					@snapshotCam="snapshotCam"
				/>
			</div>
			<div class="flex justify-end">
				<BaseButton class="mt-6 w-full btn-blue" v-if="isUploadButtonActive" @click="uploadImages">
					<font-awesome-icon :icon="['fas', 'upload']" class="mr-4"></font-awesome-icon>
					{{ imageCount }} {{ $t('upload_photos') }}
				</BaseButton>
			</div>
		</div>
	</div>
</template>

<script>
import AppsEmployee from '@/mixins/AppsEmployee';
import RepairProofCamera from '@/components/damagecases/edit/RepairProofCamera';
import BaseButton from '@/components/forms/buttons/BaseButton';
import { AppsEmployeeApiFactory } from '@/api/generated';
import apiDefaults from '@/api/defaultConfiguration';
import LoadingSpinner from '@/mixins/LoadingSpinner';

export default {
	name: 'AppsEmployeeRepairProof',
	components: { BaseButton, RepairProofCamera },
	mixins: [AppsEmployee, LoadingSpinner],
	data() {
		return {
			repairProofId: null,
			repairProof: {
				speedometerImage: {
					type: 'speedometerImage',
					title: this.$t('km_number_speedometer'),
					iconPath: require('../../../assets/Tacho.svg'),
					base64Content: null,
				},
				leftSideViewImage: {
					type: 'leftSideViewImage',
					title: this.$t('left'),
					iconPath: require('../../../assets/Auto-links.svg'),
					base64Content: null,
				},
				frontViewImage: {
					type: 'frontViewImage',
					title: this.$t('front'),
					iconPath: require('../../../assets/Auto-vorne.svg'),
					base64Content: null,
				},
				rearViewImage: {
					type: 'rearViewImage',
					title: this.$t('back'),
					iconPath: require('../../../assets/Auto-hinten.svg'),
					base64Content: null,
				},
				rightSideViewImage: {
					type: 'rightSideViewImage',
					title: this.$t('right'),
					iconPath: require('../../../assets/Auto-rechts.svg'),
					base64Content: null,
				},
				optionalDamageImages: [],
			},
			optionalDamageImage: {
				title: this.$t('originally_damage_area'),
				iconPath: require('../../../assets/Auffahrunfall.svg'),
				base64Content: null,
			},
			nextImage: null,
			isOptionalNextImage: false,
			isUploadButtonActive: false,
		};
	},
	computed: {
		imageCount() {
			return this.getImageCount();
		},
	},
	created() {
		if (!this.nextImage) {
			this.nextImage = 'speedometerImage';
		}
	},
	methods: {
		getImageCount() {
			return 5 + this.repairProof.optionalDamageImages.length;
		},
		getNextImage() {
			return this.nextImage === 'optionalDamageImages' ? this.optionalDamageImage : this.repairProof[this.nextImage];
		},
		setNextImage() {
			if (this.nextImage === 'optionalDamageImages') {
				this.optionalDamageImage.base64Content = null;
				return;
			}

			for (const imageItem in this.repairProof) {
				if (imageItem === 'optionalDamageImages') {
					this.isUploadButtonActive = true;
					this.isOptionalNextImage = true;
					this.nextImage = imageItem;
					break;
				}
				if (this.repairProof[imageItem].base64Content === null) {
					this.nextImage = imageItem;
					break;
				}
			}
		},
		snapshotCam($event) {
			if ($event.isOptional) {
				const tmpData = {
					title: this.optionalDamageImage.title,
					iconPath: this.optionalDamageImage.iconPath,
					base64Content: this.optionalDamageImage.base64Content,
				};
				this.repairProof.optionalDamageImages.push(tmpData);
				this.optionalDamageImage.base64Content = null;
			}
			this.setNextImage();
		},
		uploadImages() {
			this.setLoadingStatus(true);

			const imageCount = this.repairProof.optionalDamageImages.length + 5;
			let uploadCount = 0;

			AppsEmployeeApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
				.appsEmployeeRepairproofPost()
				.then(result => {
					this.repairProofId = result.data.id;

					for (const image in this.repairProof) {
						if (image === 'optionalDamageImages') {
							for (const optionalImage in this.repairProof.optionalDamageImages) {
								AppsEmployeeApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
									.appsEmployeeRepairproofImageRepairproofidPost(this.repairProofId, this.repairProof.optionalDamageImages[optionalImage])
									.then(result => {
										uploadCount += 1;
										if (imageCount === uploadCount) {
											this.setLoadingStatus(false);
											this.$store.commit('updateAppsEmployeeDamageCaseRepairProof', true);
											this.$swal({
												title: this.$t('general.success').toString(),
												text: this.$t('photos_uploaded').toString(),
												icon: 'success'
											}).then(_ => {
												this.$router.push({ name: 'AppsEmployeeMain' });
											});
										}
									})
									.catch(error => {
										this.$swal(this.$t('general.error').toString(), this.$t('photo_upload_error_try_again').toString(), 'error');
									});
							}
						} else {
							AppsEmployeeApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
								.appsEmployeeRepairproofImageRepairproofidPost(this.repairProofId, this.repairProof[image])
								.then(result => {
									uploadCount += 1;
									if (imageCount === uploadCount) {
										this.setLoadingStatus(false);
										this.$store.commit('updateAppsEmployeeDamageCaseRepairProof', true);
										this.$swal({
											title: this.$t('general.success').toString(),
											text: this.$t('photos_uploaded').toString(),
											icon: 'success'
										}).then(_ => {
											this.$router.push({ name: 'AppsEmployeeMain' });
										});
									}
								})
								.catch(error => {
									this.setLoadingStatus(false);
								});
						}
					}
				})
				.catch(error => {
					this.setLoadingStatus(false);
				});

			if (imageCount === uploadCount) {
				this.setLoadingStatus(false);
			}
		},
	},
};
</script>
